import useTranslation from 'next-translate/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import GModal from 'tennders-market/common/components/element/GModal'
import GHref from 'tennders-market/common/components/element/GHref'
import useForm from 'tennders-common/form/hooks/useForm'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchDeleteModal } from 'tennders-common/stores/modal/action'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import { EXTERNAL_LOAD_DELETE } from 'tennders-stracture/libs/permissions'
import useSession from 'tennders-auth/hooks/useSession'

const MDeleteTransaction = (props) => {
  const { t } = useTranslation()
  const { handleDelete } = useForm({})
  const dispatch = useDispatch()
  const { isBroker } = useSession()
  const { transaction, onDelete } = useSelector((state:StateType) => state.modal.forDelete)

  const close = () => dispatch(dispatchDeleteModal({
    transaction: null,
    onDelete: null
  }))

  const deleteLoad = async (id) => {
    close()
    handleDelete({
      id,
      url: 'loads',
      okMsg: t('addEdit:cancelledMsg'),
      confirmTitle: t('addEdit:cancelItem'),
      confirmMessage: t('addEdit:cancelAsk'),
      next: (result) => {
        if (result && onDelete) {
          onDelete()
        }
      }
    })
  }

  const deleteTruck = async (id) => {
    close()
    handleDelete({
      id,
      url: 'trucks',
      okMsg: t('addEdit:cancelledMsg'),
      confirmTitle: t('addEdit:cancelItem'),
      confirmMessage: t('addEdit:cancelAsk'),
      next: (result) => {
        if (result && onDelete) {
          onDelete()
        }
      }
    })
  }

  return (
    transaction ? (
      <GModal close={close} isOpen size={600} {...props}>

        <div className="tennders-modal-body w-100 text-center">

          <div className="d-flex">

            <div>
              <div className="p-20">
                <h3 className="bold" style={{ textAlign: 'left' }}>
                  {
                    transaction?.matchedLoad && transaction?.matchedTruck
                      ? t('addEdit:cancelTransaction')
                      : t('addEdit:deleteTransaction')
                  }
                </h3>

                <RequiresPermission requiredPermissions={isBroker() && !transaction?.matchedLoad?.internalOwner ? [
                  EXTERNAL_LOAD_DELETE
                ] : []}>
                  <GHref
                    className="btn standard-btn cursor-pointer mt-20 mr-4"
                    onClick={() => deleteLoad(transaction?.matchedLoad?.id)}
                  >
                    {' '}
                    {t('addEdit:cancelLoad')}
                    {' '}
                  </GHref>
                </RequiresPermission>
                <GHref
                  className="btn standard-btn cursor-pointer mt-20 mr-4"
                  onClick={() => deleteTruck(transaction?.matchedTruck?.id)}
                >
                  {t('addEdit:cancelTruck')}
                  {' '}
                </GHref>

              </div>
            </div>

          </div>
        </div>

      </GModal>
    ) : null
  )
}

export default MDeleteTransaction
